import { render } from "./FooterElementUpdated.vue?vue&type=template&id=43bc7982"
import script from "./FooterElementUpdated.vue?vue&type=script&lang=js"
export * from "./FooterElementUpdated.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__